import { ThemeColorModeProps } from "../utils/cpds-utils";

// Enumeration for border types
export enum BorderType {
  RoundPill = 'RoundPill',
  SquarePill = 'SquarePill'
}

// Props related to labels
interface LabelProps extends React.HTMLAttributes<HTMLElement> {
  LabelCopy?: React.ReactNode | string;
  LabelIcon?: string;
  LabelIconSize?: { width: string, height: string };
  LabelIconColor?: string;
}

// Props related to helper texts
interface HelperProps {
  HelperCopy?: string;
  HelperIcon?: string;
  HelperIconSize?: { width: string, height: string };
  HelperIconColor?: string;
}

// Common properties shared across various components
interface CommonProps extends React.HTMLAttributes<HTMLElement>, ThemeColorModeProps {
  domRef?: React.Ref<HTMLElement>;
  exClasses?: string;
  inputId?: string;
  styleOverrides?: React.CSSProperties;
  inputWidth?: string;
  isError?: boolean;
  ErrorIcon?: string;
  ErrorIconSize?: { width: string, height: string };
  ErrorMessage?: string;
  isOverRideTypography?: boolean;
  isDisabled?: boolean;
  PlaceholderCopy?: string;
  getValue?: React.Dispatch<React.SetStateAction<string>>;
}

// Props specific to input fields
export interface CpdsInputFieldsProps extends CommonProps, LabelProps, HelperProps {
  inputValue?: string;
  SubmitCopy?: string;
  SubmitIcon?: string;
  SubmitIconSize?: { width: string, height: string };
  borderType?: BorderType;
  submitEvent?: (inputValue: string) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

// Props specific to dropdown fields
export interface CpdsInputDropDownProps extends CommonProps, LabelProps, HelperProps {
  DropdownOptions?: Array<{ label: string; value: string }>;
  SelectedValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  borderType?: BorderType;
}

// Props specific to search fields
export interface CpdsSearchFieldsProps extends CommonProps {
  SearchIcon?: string;
  SearchIconSize?: { width: string, height: string };
}

// Props specific to checkbox fields
export interface CpdsCheckboxProps {
  inputId?: string;
  domRef?: React.Ref<HTMLElement>;
  exClasses?: string;
  styleOverrides?: React.CSSProperties;
  Label?: string;
  Checked?: boolean;
  onChange?: (checked: boolean) => void;
  getValue?: React.Dispatch<React.SetStateAction<boolean>>;
  isError?: boolean;
  ErrorMessage?: string;
  ErrorIcon?: string;
  ErrorIconSize?: { width: string, height: string };
  isOverRideTypography?: boolean;
}
